import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DateHelper } from '../../../helpers/date.helper';
import { Operation } from '../../../models/operation.model';
import { MessageService } from '../../../services/message.service';
import { ProductionPlanService } from '../../../services/production-plan.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-operation-displacement',
  templateUrl: 'operation-displacement.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class OperationDisplacementModalComponent implements OnInit {
  @Input() operation: Operation;
  @Output() readonly responseChanged = new EventEmitter();
  @Output() readonly operationDisplaced = new EventEmitter();

  datesWithPopulatedShifts: Array<any> = [];
  operationForm: FormGroup;
  addEmployees: boolean = false;
  currentDate: any = [];

  constructor(
    private fb: FormBuilder,
    private productionPlanService: ProductionPlanService,
    private message: MessageService,
    private sharedService: SharedService,
    private dateHelper: DateHelper
  ) {}

  ngOnInit(): void {
    this.initForm();

    const yesterday = new Date().getTime() - 24 * 60 * 60 * 1000;

    this.datesWithPopulatedShifts = this.operation.dates
      .filter(date => date.shifts.some(shift => shift.quantityPlanned))
      .filter(item => new Date(item.date).getTime() > yesterday);

    if (this.operation) {
      const initArray = this.datesWithPopulatedShifts.map(date => {
        const dateForm = {
          dateFrom: new Date(date.date),
          dateTo: null,
        };
        return this.fb.group(dateForm);
      });

      this.operationForm = this.fb.group({
        dates: this.fb.array(initArray),
      });
    }
  }

  initForm(): void {
    this.operationForm = this.fb.group({
      dates: this.fb.array([]),
    });
  }

  displaceOperation(): void {
    let shifts = [];

    const dateFromMap = new Map();
    for (const el of this.datesWithPopulatedShifts) {
      dateFromMap.set(this.formatDateFrom(el.date), el.shifts);
    }

    const dateFromSet = new Set();
    const dateToSet = new Set();
    this.datesForm.value.forEach(el => {
      const dateFrom = this.dateHelper.formatDateForFilter(el.dateFrom);
      const dateTo = this.dateHelper.formatDateForFilter(el.dateTo);

      const populatedShifts = dateFromMap.get(dateFrom);

      if (dateTo) {
        populatedShifts.forEach(el => {
          shifts.push({
            workOrderOperationId: this.operation.id,
            date: dateTo,
            shiftNumber: el.shiftNumber,
            quantityPlanned: el.quantityPlanned,
          });
        });
        dateFromSet.add(dateFrom);
        dateToSet.add(dateTo);
      }
    });

    for (const dateFrom of Array.from(dateFromSet)) {
      if (!dateToSet.has(dateFrom)) {
        for (const shiftNumber of ['I', 'II', 'III']) {
          shifts.push({
            workOrderOperationId: this.operation.id,
            date: dateFrom,
            shiftNumber: shiftNumber,
            quantityPlanned: null,
          });
        }
      }
    }

    this.productionPlanService.onSubmitOperations(this.operation.sector, this.addEmployees, shifts, true).subscribe(
      () => {
        this.message.success(`Uspešno ste pomerili izvršavanje operacije: ${this.operation.name}`);
        this.sharedService.getEventBehaviorSubject().next();
      },
      err => {
        this.message.error(err);
      }
    );

    this.emitFalse();
  }

  formatDateFrom(date: string): string {
    return date.replace(/\b0/g, '');
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  get f() {
    return this.operationForm.controls;
  }

  get datesForm() {
    return this.operationForm.get('dates') as FormArray;
  }
}
